/* Suolaa motion layer v2. No-ops without html.sm-js (reduced motion),
   in the theme editor, or without IntersectionObserver. Initializes on
   window load so section geometry is real (v1 observed a collapsed page
   and revealed everything instantly). */
(() => {
  const root = document.documentElement;
  if (!root.classList.contains('sm-js')) return;
  if (window.Shopify && Shopify.designMode) { root.classList.remove('sm-js'); return; }
  if (!('IntersectionObserver' in window)) { root.classList.remove('sm-js'); return; }

  const EASE_MS = 900;

  const countUp = (el, delayMs) => {
    const m = el.textContent.trim().match(/^(\d+)(.*)$/);
    if (!m) return;
    const end = parseInt(m[1], 10);
    const suffix = m[2] || '';
    if (!end) return;
    el.classList.add('sm-count');
    const t0 = performance.now() + delayMs;
    const tick = (now) => {
      const p = Math.min(1, Math.max(0, (now - t0) / EASE_MS));
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(end * eased) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  const init = () => {
    const sections = [...document.querySelectorAll('#MainContent .shopify-section')];
    const observed = [];

    sections.forEach((sec, idx) => {
      if (idx === 0) {
        const media = sec.querySelector('img, video');
        if (media) media.classList.add('sm-hero-media');
        return;
      }

      /* Stats section: h3 numbers => per-stat stagger + count-up */
      const stats = [...sec.querySelectorAll('h3')].filter((h) => /^\d/.test(h.textContent.trim()));
      if (stats.length >= 3) {
        sec.classList.add('sm-in'); /* container visible; children carry the reveal */
        stats.forEach((h3, i) => {
          const group = [h3];
          let n = h3.nextElementSibling;
          while (n && !/^H3$/.test(n.tagName)) { group.push(n); n = n.nextElementSibling; }
          group.forEach((el) => {
            el.classList.add('sm-reveal');
            el.style.setProperty('--sm-delay', `${i * 130}ms`);
          });
        });
        sec.dataset.smStats = '1';
        observed.push(sec);
        return;
      }

      sec.classList.add('sm-reveal');
      observed.push(sec);
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          const sec = e.target;
          if (sec.dataset.smStats) {
            sec.querySelectorAll('.sm-reveal').forEach((el) => el.classList.add('sm-in'));
            [...sec.querySelectorAll('h3')]
              .filter((h) => /^\d/.test(h.textContent.trim()))
              .forEach((h3, i) => countUp(h3, i * 130));
          } else {
            sec.classList.add('sm-in');
          }
          io.unobserve(sec);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );
    observed.forEach((el) => io.observe(el));

    /* Parallax: clipped media in below-fold sections */
    const par = [];
    sections.slice(1).forEach((sec) => {
      sec.querySelectorAll('[class*="media-wrapper"] img, [class*="media"] > img').forEach((img) => {
        if (img.closest('.sm-hero-media')) return;
        const box = img.parentElement;
        if (!box || img.offsetHeight < 260) return;
        box.classList.add('sm-par-clip');
        img.classList.add('sm-parallax');
        par.push(img);
      });
    });

    let raf = null;
    const frame = () => {
      raf = null;
      const vh = innerHeight;
      par.forEach((img) => {
        const r = img.parentElement.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        const progress = (r.top + r.height / 2 - vh / 2) / vh; /* -0.5..0.5-ish */
        const y = Math.max(-26, Math.min(26, -progress * 52));
        img.style.setProperty('--sm-par', `${y.toFixed(1)}px`);
      });
      document.body.classList.toggle('sm-scrolled', scrollY > 24);
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(frame); };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    frame();
  };

  if (document.readyState === 'complete') init();
  else addEventListener('load', init, { once: true });
})();
